import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { getListClassicSalesTicket } from '../../../../controller/api/__classic__/ticketStorage'
import { useCookies } from 'react-cookie'
import { TableRow } from '../component/TableRow'
import { calculatePage } from '../../../../helper/helper'
import Pagination from '../../../../components/Pagination'
import { Context } from '../SalesTicketStorage'

const _Table = ({region}) => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState(null)

  const [page, setPage] = useState(0)

  const ticketType = state.ticketType === 'pair' ? 'pair' : 'single'
  const pageScope = `${region}:${ticketType}`
  const [scopedPage, setScopedPage] = useState(pageScope)

  if (scopedPage !== pageScope) {
    setScopedPage(pageScope)
    setPage(0)
  }

  const getAllFunc = useCallback(async () => {

    const response = await getListClassicSalesTicket(cookies.lottmekong, {
      channel: state.channel,
      region: region,
      ticketType,
    }, page)

    if (response) {
      const res = {
        list: response.data || [],
        total: response.total,
        totalPage: calculatePage(response.total),
        ticketType,
      }
      setData(res)
    }
  }, [cookies.lottmekong, state.channel, ticketType, region, page])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{ticketType === 'pair' ? 'Danh sách cặp nguyên' : 'Danh sách vé lẻ'}</h5>
          <span className="text-muted">
            {data && data.ticketType === ticketType ? `${data.total || 0} dòng` : ''}
          </span>
        </Card.Header>
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">STT</th>
              <th scope="col">Mã vé</th>
              <th scope="col">Kỳ quay</th>
              <th scope="col">Dãy số</th>
              <th scope="col">Ký hiệu</th>
              <th scope="col">Số lượng</th>
              <th scope="col">Ngày nhập</th>
            </tr>
          </thead>
          <tbody>
            {data && data.ticketType === ticketType && data.list.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-muted py-4">
                    {ticketType === 'pair' ? 'Chưa có vé cặp nguyên' : 'Chưa có vé lẻ'}
                  </td>
                </tr>
              ) : null}
            {data && data.ticketType === ticketType && data.list.map((pv, index) => <TableRow rIndex={index} key={`table-keys-lottmekong-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={(data && data.ticketType === ticketType && data.totalPage) || 0}
                currentPage={page || 0}
                onPageChange={(i) => {
                  setPage(i)
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)